/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Invoice_DownloadInputs */

const cs_billing_invoice_download = /** @type {(inputs: Billing_Invoice_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáhnout PDF`)
};

const en_billing_invoice_download = /** @type {(inputs: Billing_Invoice_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download PDF`)
};

/**
* | output |
* | --- |
* | "Download PDF" |
*
* @param {Billing_Invoice_DownloadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_invoice_download = /** @type {((inputs?: Billing_Invoice_DownloadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Invoice_DownloadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_invoice_download(inputs)
	return cs_billing_invoice_download(inputs)
});